import React from "react";

interface ICounterCircle {
  currentValue: number;
  maxValue: number;
}

const CounterCircle = ({ currentValue, maxValue }: ICounterCircle) => {
  const progressPercentage = (currentValue / maxValue) * 100;

  return (
    <div
      className="flex items-center justify-center w-10 h-10 rounded-full bg-white relative"
      style={{
        background: `conic-gradient(#7588df ${progressPercentage}%, #e6e5f1 ${progressPercentage}%)`,
      }}
    >
      <div
        className="flex items-center justify-center w-8 h-8 rounded-full bg-white"
        style={{
        }}
      >
        <div className="font-bold text-sm">{`${currentValue}/${maxValue}`}</div>
      </div>
    </div>
  );
};

export default CounterCircle;
